'use client';

import React, { useState } from 'react';
import { Menu, X, Bot } from 'lucide-react';

interface NavbarProps {
  onOpenBooking: () => void;
  brandLabel?: string;
}

const Navbar: React.FC<NavbarProps> = ({ onOpenBooking, brandLabel = 'Sales Agent AI' }) => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - headerOffset;

      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
    setIsOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 w-full bg-slate-950/85 backdrop-blur-md z-50 border-b border-cyan-400/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex-shrink-0 flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <div className="bg-cyan-400 p-1.5 rounded-lg">
              <Bot className="h-6 w-6 text-slate-950" />
            </div>
            <span className="font-bold text-xl tracking-tight text-slate-100">{brandLabel}</span>
          </div>

          <div className="hidden md:flex items-center gap-6">
            <a
              href="#jak-to-dziala"
              onClick={(e) => scrollToSection(e, 'jak-to-dziala')}
              className="text-slate-300 hover:text-cyan-300 font-medium transition"
            >
              Jak to działa
            </a>
            <a
              href="#roi"
              onClick={(e) => scrollToSection(e, 'roi')}
              className="text-slate-300 hover:text-cyan-300 font-medium transition"
            >
              Kalkulator
            </a>
            <button
              onClick={onOpenBooking}
              className="bg-cyan-400 hover:bg-cyan-300 text-slate-950 px-5 py-2.5 rounded-full font-bold transition"
            >
              Bezpłatna kwalifikacja →
            </button>
          </div>

          <div className="md:hidden flex items-center">
            <button onClick={() => setIsOpen(!isOpen)} className="text-slate-300 hover:text-cyan-300 focus:outline-none">
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-slate-950 border-t border-cyan-400/20 absolute w-full shadow-lg">
          <div className="px-4 pt-2 pb-6 flex flex-col items-center">
            <a
              href="#roi"
              onClick={(e) => scrollToSection(e, 'roi')}
              className="block px-3 py-3 text-base font-medium text-slate-300 hover:text-cyan-300 w-full text-center"
            >
              Kalkulator Oferty
            </a>
            <button
              onClick={() => {
                setIsOpen(false);
                onOpenBooking();
              }}
              className="mt-2 w-full bg-cyan-400 text-slate-950 px-5 py-3 rounded-lg font-bold"
            >
              Formularz
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
